export default "__VITE_ASSET__DYJuVvHQ__"